// Build a document that allows a user to submit a Sigma URL and then fetch the data from the Sigma API using a Lambda function
// The Lambda function will use the Sigma API to fetch the data and return it to the client
// The client will then display the results in the resultsContainer


document.getElementById('resultContainer').innerHTML = '';


document.getElementById('sigmaUrlForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    const workbookUrl = document.getElementById('workbookUrl').value;
    var lambdaUrl = 'https://fbi55jk5ouyqcsnxcnbiio2cui0zqydd.lambda-url.us-east-1.on.aws/'; // Replace with your Lambda URL

    // Confirm that the submission is a valid Sigma URL, it should start with https://app.sigmacomputing.com
    if (!workbookUrl.startsWith('https://app.sigmacomputing.com')) {
        alert('Invalid Sigma URL, please be sure your URL starts with https://app.sigmacomputing.com');
        return;
    }

    // Parse the url to get the workbookId, it will be the last part of the path, separated by '-'
    // First, strip the params
    const workbookUrlParts = workbookUrl.split('?');
    const workbookNoParams = workbookUrlParts[0];
    const workbookNoEdit = workbookNoParams.split('/edit')[0];
    const workbookId = workbookNoEdit.split('/').pop().split('-').pop();

    lambdaUrl += `?workbook_id=${workbookId}`;

    // Regex to check if the workbookId is a valid UUID
    const uuidRegex = /[0-9A-Za-z]+/;
    
    // Confirm the workbookId is valid
    if ((!workbookId) || (workbookId.match(uuidRegex) === null)) {
        alert('Invalid Sigma URL, please be sure to copy the full URL with the workbookId');
        return;
    }

    // Once we've confirmed the workbookId is valid, we can fetch the data from the Lambda function
    // and update the resultContainer to show a loading message
    
    var resultContainer = document.getElementById('resultContainer');
    var spanElement = document.createElement('span');
    resultContainer.classList.add('spinner-grow')
    resultContainer.role = 'status'
    spanElement.classList.add('visually-hidden');
    spanElement.textContent = 'Loading...';
    resultContainer.appendChild(spanElement);

    try {
        const response = await fetch(lambdaUrl, {
            method: 'GET'            
        });

        if (response.ok) {
            const data = await response.json();
            const embedUrl = data.embedUrl;
            // Display the results in the resultsContainer without double quotes
            resultContainer.classList.remove('spinner-grow');
            resultContainer.role = '';
            spanElement.classList.remove('visually-hidden');
            spanElement.classList.add('bg-success', 'text-white', 'p-3', 'rounded-3');
            spanElement.textContent = JSON.stringify(embedUrl).replace(/"/g, '');

            // create a 'copy' button for the spanElement's textContent
            var copyButton = document.createElement('button');
            copyButton.classList.add('btn', 'btn-light', 'ms-3', 'rounded-3', 'p-3', 'border');
            copyButton.textContent = 'Copy';
            copyButton.onclick = function() {
                navigator.clipboard.writeText(spanElement.textContent);
            }

            // Create a container for the spanElement and copyButton
            var container = document.createElement('div');
            container.classList.add('d-flex', 'align-items-center');
            container.appendChild(spanElement);
            container.appendChild(copyButton);

            resultContainer.appendChild(container);  
        } else {
            throw new Error('Failed to fetch results');
        }
    } catch (error) {
        console.error(error);
        alert('Failed to fetch results, please check your Sigma URL and try again. If the problem persists, please contact Eric Heidbreder on LinkedIn');
        // Handle error
    }
}); // Add closing parenthesis here
